import script from "./AggregationSuggestionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AggregationSuggestionItem.vue?vue&type=script&setup=true&lang=ts"

import "./AggregationSuggestionItem.vue?vue&type=style&index=0&id=6883fbe7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6883fbe7"]])

export default __exports__